import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import dayjs, { Dayjs } from 'dayjs';

interface DatePickerProps {
  labelValue: string;
  selectedDate: Dayjs | null;
  setSelectedDate: (newDate: Dayjs | null) => void;
  minDate?: Dayjs;
  maxDate?: Dayjs;
  isReadOnly?: boolean;
}

const DatePickerComponent: React.FC<DatePickerProps> = ({
  labelValue,
  selectedDate,
  setSelectedDate,
  minDate,
  maxDate,
  isReadOnly = false
}) => {
  // const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);

  const handleDateChange = (newDate: Dayjs | null) => {
    setSelectedDate(newDate);
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          readOnly={isReadOnly}
          sx={{width: '100%'}}
          label={labelValue}
          value={selectedDate}
          minDate={minDate}
          maxDate={maxDate || dayjs().add(1, 'year')}
          onChange={handleDateChange}
          format='DD MMM YYYY'
        />
    </LocalizationProvider>
  );
};

export default DatePickerComponent;
